<template>
  <page-outline :title="$t('Webheader.configuration_tb')">
    <template slot="pageContent">

      <div class="listPage overflow-hidden">
        <b-container fluid class="listPage">

          <b-row class="text-xl-start mb-3">
            <b-col xl="6" lg="9" md="12" cols="12">
              <b-button-group class="mt-3 mt-sm-0">
                <b-button class="px-4" :variant="tabName === 1 ? 'primary btn-selected' : ''" @click="changeTabName(1)">{{ $t('common.global.corporate_identifier_type') }}</b-button>
                <b-button class="px-4" :variant="tabName === 2 ? 'primary btn-selected' : ''" @click="changeTabName(2)">{{ $t('entities_setting_tb.connector_in') }}</b-button>
                <b-button class="px-4" :variant="tabName === 3 ? 'primary btn-selected' : ''" @click="changeTabName(3)">{{ $t('entities_setting_tb.connector_out') }}</b-button>
              </b-button-group>
            </b-col>
          </b-row>



          <br />

          <CorporateIdentifierType v-if="tabName === 1"></CorporateIdentifierType>
          <WebServiceCredentialDetails v-else-if="tabName === 2" tb="1"  mode="details"></WebServiceCredentialDetails>
          <WebServiceConfigurationDetails v-else-if="tabName === 3" tb="1"  mode="details"></WebServiceConfigurationDetails>



        </b-container>
      </div>
    </template>
  </page-outline>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage} from "@/helpers/routing";
import {errorMessageAlert} from "@/helpers/alert";
import CorporateIdentifierType from "@/pages/routing/CorporateIdentifierTypeTB.vue";
import WebServiceCredentialDetails from "@/pages/routing/WebServiceCredentialDetailsTB.vue";
import WebServiceConfigurationDetails from "@/pages/routing/WebServiceConfigurationDetailsTB.vue";

export default {
  name: 'EntitiesSettingsTB',
  components: {
    'page-outline': PageOutline,
    CorporateIdentifierType,
    WebServiceCredentialDetails,
    WebServiceConfigurationDetails,
  },
  props: {
  },
  computed: {
  },
  data () {
    return {
      activateSpinner: false,
      IsRVM: 0,
      options: [
        { IdCIT: "1", Name: "BICC" },
        { IdCIT: "2", Name: "LEIC" },
        { IdCIT: "3", Name: "SCHEME_NAME_CODE" },
        { IdCIT: "4", Name: "SCHEME_NAME_PROPRIETARY" }
      ],
      selectedValues: {},
      tabName: 1,
      IdMessageRouting: null
    }
  },
  created () {
    this.onRefresh()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
    changeTabName (tabName) {
      this.tabName = tabName
    },
    onRefresh () {
      this.activateSpinner = true

      this.refreshItems()

      this.$f7.pullToRefreshDone()
    },
    refreshItems () {
      let that = this
      this.$engine.routing.message.fetchTB().then(resp => {


        this.IsRVM = resp.data.isRVM == 1 ? true : false;


        if (resp.data.cit.length > 0) {

          const receivedValues = resp.data.cit.map(item => item.Name)
          this.IdMessageRouting = resp.data.cit[0].IdMessageRouting

          if (resp.data.cit[0].Name != ''){
            this.options.forEach(option => {
              this.$set(this.selectedValues, option.Name, receivedValues.includes(option.Name) ? 1 : 0);
            })
          }
        }


        that.activateSpinner = false
      })
          .catch(error => {
            that.activateSpinner = false
            errorMessageAlert(error, that)
          })
    },
    getConfigurationTB () {
      loadPage(this, {url: '/routing/configTB/1/details'})
    },
    getCredentialTB () {
      loadPage(this, {url: '/routing/credentialTB/1/details'})
    },
    updateConfigurationTB () {
      let form = {
        IdMessageRouting: this.IdMessageRouting,
        inputFileBase64: this.inputFileBase64,  // Base64 pour le fichier d'entrée
        outputFileBase64: this.outputFileBase64, // Base64 pour le fichier de sortie
      }

      this.options
          .filter(option => this.selectedValues[option.Name] === 1) // Garde ceux qui sont cochés
          .forEach(option => {
            form[option.Name] = option.IdCIT; // Ajoute au form
          })

      // Appel API
      this.$engine.routing.message.updateConfigurationTB(form)
          .then(resp => {
            if (resp.headers['content-length'] && parseInt(resp.headers['content-length'], 10) !== 0) {
              this.$bvToast.toast(this.$t('entities_setting_tb.updated_successfully'), {
                title: this.$t('success'),
                variant: 'success',
                solid: true
              });
            } else {
              this.$bvToast.toast(this.$t('entities_setting_tb.update_error'), {
                title: this.$t('error'),
                variant: 'danger',
                solid: true
              });
            }
          })
          .catch(e => {
            console.error("Erreur lors de la mise à jour :", e);
            this.$bvToast.toast(this.$t('entities_setting_tb.update_error'), {
              title: this.$t('error'),
              variant: 'danger',
              solid: true
            });
          });
    },
  }
}
</script>
